<template>
  <el-dialog :visible.sync="shareDialogVisible" width="400px" title="分享链接" @close="close">
    <el-tabs v-model="activeName" :stretch="true">
      <!-- <el-tab-pane label="H5" name="1">
          <div class="qrcode-wrap">
            <div class="qrcode">
              <img :src="h5_code" alt="">
            </div>
            <div class="tc deal-wrap">
              <el-button type="primary" size="mini" @click="downloadImg(h5_code)">保存二维码</el-button>
            </div>
            <div class="path">
              <p>{{h5_path}}</p>
              <div class="tc deal-wrap">
                <el-button type="primary" size="mini"  @click="copy(h5_path)">复制链接</el-button>
              </div>
            </div>
          </div>
      </el-tab-pane>-->

      <el-tab-pane label="小程序" name="2">
        <div class="qrcode-wrap">
          <div class="qrcode" v-if="imgLink" v-loading="imgLoading">
            <img :src="imgLink" alt />
          </div>
          <div class="tc deal-wrap">
            <el-button type="primary" size="mini" @click="downloadImg(imgLink,'二维码')">保存二维码</el-button>
        </div>
          <!-- <div class="path">
            <p>{{imgLink}}</p>
            <div class="tc deal-wrap">
              <el-button type="primary" size="mini" @click="copy(imgLink)">复制链接</el-button>
            </div>
          </div> -->
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import util from "@/base/js/util";

export default {
  props: {
    shareVisible: {
      type: Boolean,
      default: false
    },
    wx_code: {
      default: require("../../../assets/logo.png")
    },
    wx_path: {
      default: "pages/index/index"
    },
    share_info: {
      type: Object,
    }
  },
  computed: {},
  watch: {
    shareVisible(newVal) {
      this.shareDialogVisible = newVal;
    },
    share_info(val){
      this.couseShare(this.share_info);
    },
  },
  data() {
    return {
      shareDialogVisible: false,
      activeName: "2",
      imgLink:'',
      imgLoading:true
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    close() {
      this.imgLink='';
      this.$emit("update:shareVisible", false);
    },
    downloadImg(url) {
      util.downloadIamge(url);
    },
    //复制链接
    copy(text = "复制失败，请重试") {
      this.$copyText(text)
        .then(() => {
          this.$message.success("复制成功");
        })
        .catch(e => {
          this.$message.error("复制失败");
          console.log(e);
        });
    },
    //加载分享二维码
    couseShare(shareInfo) {
      if (shareInfo.type == 1) {
        this.imgLink=`/admin/xcx/course?course_id=${shareInfo.id}`;
      } else if (shareInfo.type == 2) {
        this.imgLink=`/admin/xcx/topic?topic_id=${shareInfo.id}`;
      }
      this.imgLoading=false;
    }
  }
};
</script>

<style lang="less" scoped>
.qrcode {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  img {
    height: 100%;
    width: 100%;
  }
}
.deal-wrap {
  margin: 10px 0;
}
</style>
